// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"74c8faff","236":"24fac6fd","270":"0950d526","277":"1723cc83","513":"d8e1322d","703":"6f521d0e","770":"fc8f4758"}[chunkId] + ".chunk.js";
};